import { FileText, Phone, Mail, Shield, AlertTriangle, Clock, CreditCard, Truck, Wrench, Users, Scale } from 'lucide-react'

const CGV = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="container-custom py-8">
          <div className="flex items-center mb-4">
            <FileText className="h-8 w-8 text-orange-500 mr-3" />
            <h1 className="text-3xl font-bold text-gray-900">Conditions Générales de Location</h1>
          </div>
          <p className="text-gray-600">
            FLIGHTCASE FWI SASU au capital social de 7500,00 € – RCS POINTE-À-PITRE 882469174 – N° Siret 88246917400016
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="container-custom py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          
          {/* Article 1 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Scale className="h-6 w-6 text-orange-500 mr-2" />
              1 • CHAMPS D'APPLICATION
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Les présentes conditions générales de location ont été régulièrement portées à la connaissance de tous les locataires. Elles sont donc applicables à toute location conclue en France ou à l'étranger et quel que soit le lieu d'utilisation de la marchandise louée sauf stipulations contraires prévues par écrit et signées par une personne habilitée de FLIGHTCASE FWI.
              </p>
              <p>
                Le bénéfice du contrat de location est propre au Locataire : la sous-location du matériel, la cession de bail et le prêt s'ils sont pratiqués, sont de la responsabilité du Locataire qui en assumera toutes les conséquences.
              </p>
            </div>
          </section>

          {/* Article 2 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Clock className="h-6 w-6 text-orange-500 mr-2" />
              2 • MODALITÉS DE LOCATION
            </h2>
            
            <div className="space-y-6">
              {/* 2.1 */}
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">2.1 • RÉSERVATION</h3>
                <div className="space-y-4 text-gray-700">
                  <p>
                    La réservation s'effectue par téléphone au numéro : <strong>+590 590 265 430</strong>, par e-mail : <strong>planning@flightcasefwi.com</strong>. Toute demande de réservation fait l'objet d'un devis envoyé par FLIGHTCASE FWI.
                  </p>
                  <p>
                    La réservation du matériel implique le renvoi du devis signé. À défaut le matériel n'est pas bloqué.
                  </p>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-3">Pour les entreprises :</h4>
                    <p className="text-gray-700">
                      L'enlèvement du matériel s'effectue en échange du devis signé pour les sociétés ayant un compte dans nos registres ainsi que la signature du bon de livraison.
                    </p>
                    <p className="text-gray-700 mt-2">
                      Sans compte, le locataire doit envoyer un K BIS de moins de 3 mois, un RIB, une pièce d'identité et le paiement intégral de la location avant l'enlèvement du matériel ou au plus tard le jour de l'enlèvement du matériel (pour la première location uniquement). La signature du devis, vaut commande.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-3">Pour les Associations :</h4>
                    <p className="text-gray-700">
                      Le Locataire doit envoyer le récépissé de déclaration, un RIB, une pièce d'identité et le paiement intégral de la location avant l'enlèvement du matériel ou au plus tard le jour de l'enlèvement du matériel. La signature du devis, vaut commande.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 mb-3">Pour les particuliers :</h4>
                    <p className="text-gray-700">
                      Le Locataire doit envoyer un justificatif de domicile, un RIB, une pièce d'identité et le paiement intégral de la location avant l'enlèvement du matériel ou au plus tard le jour de l'enlèvement du matériel. La signature du devis, vaut commande.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-gray-800">
                      <strong>Important :</strong> La commande doit être complète et comprendre les accessoires, FLIGHTCASE FWI ne garantissant pas les oublis. La commande doit-être envoyée avant l'enlèvement des marchandises ou déposée dans les locaux de FLIGHTCASE FWI lors de l'enlèvement au plus tard.
                    </p>
                  </div>
                </div>
              </div>

              {/* 2.2 */}
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">2.2 • DURÉE DE LA LOCATION</h3>
                <div className="space-y-4 text-gray-700">
                  <p>
                    Le matériel loué est accompagné d'un bon de livraison sur lequel figure la date et l'heure de l'enlèvement, le récapitulatif de la liste des équipements ainsi que le jour et l'heure du retour des dits équipements.
                  </p>
                  <p>
                    La durée de la location s'exprime en journée. Elle commence du jour prévu de l'enlèvement lorsque l'enlèvement a lieu avant 12H00, le lendemain si l'enlèvement est effectué après 15H00 et s'achève au jour prévu de la restitution de l'intégralité du matériel, lorsque la restitution a lieu après 12H00 ou la veille en cas de restitution avant 11H00.
                  </p>
                  <p className="font-semibold text-gray-600">
                    Les éventuelles prolongations seront facturables en plus.
                  </p>
                </div>
              </div>

              {/* 2.3 */}
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">2.3 • ENLÈVEMENT DU MATÉRIEL, ÉTAT ET GARDE</h3>
                <div className="space-y-4 text-gray-700">
                  <p>
                    Le matériel pris en charge dans nos locaux, par le locataire, est réputé en bon état de fonctionnement tant sur le plan technique que sur le plan du respect des consignes et règles de sécurité indiquées par le constructeur ou par les règlements en vigueur au jour de ladite prise en charge.
                  </p>
                  <p>
                    Le locataire doit, avant l'enlèvement, tester l'ensemble du matériel. L'enlèvement implique la reconnaissance du bon fonctionnement du matériel et de sa conformité à la commande.
                  </p>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-gray-800 font-semibold">
                      Aucune contestation ne pourra être acceptée postérieurement à la signature du contrat de location si celui-ci ne mentionne pas de réserves. Aucune réclamation ne pourra être prise en compte après le départ du matériel.
                    </p>
                  </div>
                </div>
              </div>

              {/* 2.4 */}
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">2.4 • RESTITUTION DU MATÉRIEL ET PROLONGATION DE LA LOCATION</h3>
                <div className="space-y-4 text-gray-700">
                  <p>
                    L'enlèvement et la restitution des appareils s'effectuent dans les locaux de FLIGHTCASE FWI ; aux dates et heures prévues sur le devis ou le bon de réservation ; ils sont à la charge du Locataire qui l'accepte.
                  </p>
                  <p>
                    Toute prolongation de location devra être signalée à l'avance et fera l'objet d'une facturation complémentaire, selon les conditions de location convenues.
                  </p>
                </div>
              </div>

              {/* 2.5 */}
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">2.5 • ANNULATION OU REPORT DE LA LOCATION</h3>
                <div className="space-y-4 text-gray-700">
                  <p>
                    Toute annulation ou report doivent être notifiés à FLIGHTCASE FWI par écrit au moins vingt-quatre (24) heures avant le début de la période de location.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Article 3 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <CreditCard className="h-6 w-6 text-orange-500 mr-2" />
              3 • PRIX, FACTURATION ET DÉLAI DE PAIEMENT
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Nos prestations sont facturées sur la base des tarifs indiqués dans notre catalogue dont le Locataire reconnaît avoir pris connaissance ; ces tarifs s'entendent hors taxes et hors assurances sous réserve de la disponibilité des matériels et sont soumis aux taxes en vigueur au moment de l'établissement de la facture.
              </p>
              <p>
                Aucun rabais ne peut être consenti par suite d'immobilisations, tels : grèves, douanes, arrêts ou suspensions du tournage, etc. ou de dysfonctionnements du matériel qui ne soit pas de notre fait.
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-800 font-semibold">
                  Toute commande annulée ou reportée, moins de vingt-quatre (24) heures avant la date prévue de mise à disposition du matériel, donnera lieu à la facturation d'une indemnité équivalent à 10 % de la valeur de la location prévue initialement.
                </p>
              </div>
            </div>
          </section>

          {/* Article 4 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Wrench className="h-6 w-6 text-orange-500 mr-2" />
              4 • ENTRETIEN ET RÉPARATION DU MATÉRIEL LOUÉ
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Toute remise en état diligentée en cours de Location par le Locataire doit faire l'objet d'une autorisation écrite du Loueur. À la demande du Locataire, le service de maintenance de FLIGHTCASE FWI pourra intervenir sur site. Les frais de déplacement seront à la charge du locataire.
              </p>
              <p>
                Le Locataire veille à la conservation et à la bonne utilisation du matériel. En cas de casse ou de détérioration du matériel, involontaire ou dû à une mauvaise utilisation, le locataire sera redevable de toutes les charges de remise en état.
              </p>
            </div>
          </section>

          {/* Article 5 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Users className="h-6 w-6 text-orange-500 mr-2" />
              5 • UTILISATION DU MATÉRIEL ET RESPONSABILITÉS
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">5.1 • UTILISATION DU MATÉRIEL</h3>
                <p className="text-gray-700">
                  Le Locataire s'engage expressément à ne confier l'utilisation des matériels qu'à des techniciens confirmés et compétents.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">5.2 • RESPONSABILITÉ DU LOUEUR</h3>
                <p className="text-gray-700">
                  Le Loueur (FLIGHTCASE FWI) est tenu d'une obligation de moyen. Compte tenu de la nature et de la fragilité des composants du matériel loué, la responsabilité du loueur est exclue en cas de vices, dysfonctionnements, défauts ou anomalies empêchant le locataire d'utiliser le matériel loué, résultant directement ou non du fabricant ou du fournisseur du matériel.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">5.3 • RESPONSABILITÉ DU LOCATAIRE</h3>
                <p className="text-gray-700">
                  Conformément à l'article 1728 du code civil, le Locataire s'engage à utiliser la chose louée en bon père de famille, suivant la destination habituelle du matériel qui lui est confié. Le Locataire sera responsable à l'égard des tiers de l'utilisation du matériel sans recours contre le Loueur à quelque titre que ce soit et supportera tout risque relatif à la garde et à l'utilisation du matériel.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">5.4 • CAUTION</h3>
                <div className="space-y-4 text-gray-700">
                  <p>
                    Pour tout client, une caution (chèque, espèces, carte bleue) d'un montant minimum de 300 euros, selon la nature et la valeur du matériel loué (15%), sera exigée avant la délivrance du matériel, et encaissable à la convenance de FLIGHTCASE FWI.
                  </p>
                  <p>
                    Pour tout client étranger, il sera exigé, même en cas de pré-paiement, un dépôt d'espèces égal à 1.5 x le prix de la location prévue.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Article 6 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Shield className="h-6 w-6 text-orange-500 mr-2" />
              6 • CONDITIONS D'ASSURANCES
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">6.1 • LES DOMMAGES GARANTIS</h3>
                <p className="text-gray-700">
                  L'assurance couvre les dommages causés au matériel loué à tout bris, incendie, destruction, vol, perte et vandalisme. L'assurance s'applique dans le monde entier.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">6.2 • EXCLUSIONS DE GARANTIE</h3>
                <p className="text-gray-700">
                  Tous les autres risques sont exclus et notamment: les dégâts consécutifs à l'usure normale et des risques prévisibles quelle qu'en soit l'origine, provenant de l'effet prolongé de l'exploitation tels que oxydation, corrosion, incrustation de rouille, sable.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">6.3 • FRANCHISE</h3>
                <p className="text-gray-700">
                  L'assurance s'applique moyennant une franchise égale à 15 % du montant des dommages subis avec un minimum de 300 € H.T par sinistre. Elle est à la charge exclusive du Locataire.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">6.4 • FACTURATION ASSURANCE</h3>
                <p className="text-gray-700">
                  Pour le Locataire qui opte pour les garanties proposées par FLIGHTCASE FWI, l'assurance est facturée 8% de la valeur locative du matériel hors remise.
                </p>
              </div>
            </div>
          </section>

          {/* Article 7 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Truck className="h-6 w-6 text-orange-500 mr-2" />
              7 • EXPORTATION DU MATÉRIEL LOUÉ
            </h2>
            <p className="text-gray-700">
              Le Locataire assumera entièrement les formalités de douane.
            </p>
          </section>

          {/* Article 8 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <AlertTriangle className="h-6 w-6 text-orange-500 mr-2" />
              8 • RÉSILIATION
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Le non-paiement à la bonne date d'une facture, de même que la non restitution du matériel à la date prévue, entraînera de plein droit à l'initiative du Loueur la résiliation immédiate du contrat de location aux torts exclusifs du Locataire qui demeurera tenu au paiement de l'intégralité du prix de location, à titre d'indemnité.
              </p>
              <p>
                À réception de la résiliation notifiée par le Loueur, le Locataire disposera de quarante-huit (48) heures pour restituer le matériel.
              </p>
            </div>
          </section>

          {/* Article 9 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Scale className="h-6 w-6 text-orange-500 mr-2" />
              9 • CLAUSE ATTRIBUTIVE DE COMPÉTENCE
            </h2>
            <p className="text-gray-700">
              Tout litige relatif à l'interprétation qu'à l'exécution des conditions générales, sera de la compétence exclusive du tribunal de pointe-à-pitre, même en cas de pluralité de défendeurs, et sera jugé selon la loi française.
            </p>
          </section>

          {/* Contact */}
          <section className="border-t pt-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Contact</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-gray-600" />
                  <span className="text-gray-700">+590 590 265 430</span>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="h-5 w-5 text-gray-600" />
                  <span className="text-gray-700">planning@flightcasefwi.com</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default CGV
